// @ts-check
import { gql, useQuery } from '@apollo/client';
import { Trans } from '@lingui/macro';
import { useParams } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import ValidateIdentifier, {
  useIdentifierValidation,
} from '../identifierValidation/IdentifierValidation';
import {
  ProgressIndicator,
  bottlebooksFieldsSource,
  fieldsToImport,
  useLink,
} from './_config';

export default function IdentifierValidation({ match }) {
  const { workspaceId, importId } = match.params;
  const props = useIdentifierValidation({ workspaceId, importId });

  const link = useLink('identifierValidation');
  const { loading, addedCount } = useData();
  if (loading) return null;

  return (
    <Layout>
      <ProgressIndicator step={addedCount > 0 ? 'identifyFields' : 'mapData'} />
      <PageHeader>
        <PageTitle>
          <Trans>Product IDs validation</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>
            Rows with IDs we can't match to your products will be imported as
            new products.
          </Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <ValidateIdentifier
          {...props}
          masterListColumns={[...fieldsToImport, ...bottlebooksFieldsSource]}
          redirectToIfValid={link.next()}
          addedCount={addedCount}
          loading={loading || props.loading}
        />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton to={link.next()} disabled={!props.isValid}>
          <Trans>Next</Trans>
        </NextButton>
      </Footer>
    </Layout>
  );
}

function useData() {
  const { workspaceId, importId } = useParams();
  const { data, loading } = useQuery(QUERY, {
    variables: {
      workspaceId,
      importId,
    },
    fetchPolicy: 'network-only',
  });
  return {
    loading,
    addedCount: data?.workspace?.dataImport?.preview?.[0]?.addedCount,
  };
}
const QUERY = gql`
  query IdentifierValidation($workspaceId: ID!, $importId: ID!) {
    workspace(workspaceId: $workspaceId) {
      workspaceId
      dataImport(importId: $importId) {
        importId
        preview {
          addedCount
        }
      }
    }
  }
`;
